import React, { Component } from 'react';
import Dropdown from 'react-dropdown'
import {setContextualHelp} from "actions/index.js";
import {ENVELOPE_TRACK_DROPDOWN} from 'constants/contextual-help.js';
import { connect } from "react-redux";
import {PRE_FX, POST_FX} from 'modulators/constants.js';

const MAX_NAME_LENGTH = 16;

class EnvelopeTrackDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    onSelectTrack(o) {
        // first check if any tracks have this one
        for (let i in this.tracks) {
            if (this.tracks[i].isConnectedToEnvelope(this.props.envelope)) {
                this.tracks[i].disconnectFromEnvelope(this.props.envelope);
            }
        }
        let track = o.value;
        track.connectToEnvelope(this.props.envelope);
        this.setState(this.state);
    }

    getTruncatedName(track) {
        let name = track.getName();
        if (name === undefined) {
            return '';
        }
        if (name.length >= MAX_NAME_LENGTH) {
            return name.slice(0, MAX_NAME_LENGTH) + '...';
        }

        return name;
    }

    getOptions() {
        return this.props.sequencerEngine.tracks.map(
            track => (
                {
                    label: (track.trackNumber + 1) + '. ' + this.getTruncatedName(track),
                    value: track}
            ));
    }

    getSelectedOption() {
        return this.getOptions()
            .filter(x => x.value.isConnectedToEnvelope(this.props.envelope))[0];
    }

    render() {
        let className = this.props.isSelected  &&
            this.getSelectedOption() === undefined ?
            "envelope-dropdown osc-type-dropdown-container selected" :
            "envelope-dropdown osc-type-dropdown-container";
        return (
            <div
              onMouseOver={() => this.props.setContextualHelp(ENVELOPE_TRACK_DROPDOWN)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              className={className}>
              <Dropdown
                controlClassName='osc-type-control-dropdown'
                arrowClassName='osc-type-arrow-dropdown'
                options={this.getOptions()}
                onChange={(o) => this.onSelectTrack(o)}
                value={this.getSelectedOption()}
                placeholder="Track" />
                <div className="clear-fix"/>
                <div className="pre-post-options">
                  <div
                    onClick={() => this.onClickMode(PRE_FX)}
                    className={this.preFXClassName}>Pre-FX</div>
                  <div
                    onClick={() => this.onClickMode(POST_FX)}
                    className={this.postFXClassName}>Post-FX</div>
                </div>
            </div>
        );
    }

    onClickMode(mode) {
        let track = this.connectedTrack;
        if (track === undefined) {
            return;
        }

        track.setEnvelopeMode(this.props.envelope, mode);

        this.setState(this.state);
    }

    get tracks() {
        return this.props.sequencerEngine.tracks;
    }

    get connectedTrack() {
        return this.tracks.filter(
            track =>
                track.isConnectedToEnvelope(
                    this.props.envelope))[0];
         
    }

    get mode() {
        let track = this.connectedTrack;
        if (track === undefined) {
            return undefined;
        }

        return track.getEnvelopeMode(this.props.envelope);
    }

    get preFXClassName() {
        return this.mode !== undefined && 
            this.mode !== POST_FX ?
            "pre-post-option selected" :
            "pre-post-option";
    }

    get postFXClassName() {
        return this.mode !== undefined && 
            this.mode !== PRE_FX ?
            "pre-post-option selected" :
            "pre-post-option";
    }
}

const mapStateToProps = state => {
    return {
        tracks: state.tracks.trackSteps,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(mapStateToProps, mapDispatchToProps)(EnvelopeTrackDropdown);
